import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { List, Title, Wrap } from './styled';
import { groupAccessories } from '../../../domain/shop-groupers';
import genKey from '../../../utils/gen-key';
import GroupCard from '../../Shop/GroupCard';
import { getItemAdditionalGoods } from '../../../utils/api/items';
import pagesInfo from '../../../domain/pages-info';

function Shop({ isRequiredProduct }) {
  const allItems = useSelector((state) => state.items.list);
  const accessories = new Set();
  allItems.forEach((item) => {
    if (!isRequiredProduct(item)) {
      return;
    }
    getItemAdditionalGoods(item).forEach((good) => accessories.add(good));
  });
  const list = [];
  [...accessories].forEach((itemId) => {
    const found = allItems.find((item) => item.id === itemId);
    if (found === undefined) {
      return;
    }

    found.url = Object.values(pagesInfo).filter(
      (item) => item.title === found.product.name
    )[0].url;
    list.push(found);
  });

  const groups = groupAccessories(list);

  return (
    <Wrap>
      <Title>
        <FormattedMessage id="product.shop.title" />
      </Title>
      <List>
        {groups.map((group) => (
          <GroupCard
            group={group}
            href={group.items[0].url}
            cardKey={genKey()}
            key={genKey()}
            large
          />
        ))}
      </List>
    </Wrap>
  );
}

export default Shop;

Shop.propTypes = {
  isRequiredProduct: PropTypes.func.isRequired,
};
